import script from "./AtomInputSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomInputSearch.vue?vue&type=script&lang=ts&setup=true"

import "./AtomInputSearch.vue?vue&type=style&index=0&id=4cf48b02&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf48b02"]])

export default __exports__